import {z} from 'zod'
import {useTranslation} from '@/translations/i18n'
import {Controller, useFormContext} from 'react-hook-form'
import {MedicalReportFieldsSchema} from '../../formSchemas'
import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {familySituationMinorsMapToLabel} from '../../utils'

const FamilySituationMinorSchema = MedicalReportFieldsSchema.pick({
    familySituationMinors: true
})
type FamilySituationMinorSchema = z.infer<typeof FamilySituationMinorSchema>

export const FamilySituationMinorsField = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<FamilySituationMinorSchema>()

    return (
        <Controller
            name="familySituationMinors"
            control={control}
            render={({field, fieldState}) => (
                <InputSelect
                    label={t('medical_records:select_family_situation')}
                    value={field.value}
                    placeholder={t('commons:select')}
                    optionsMap={familySituationMinorsMapToLabel}
                    errorMessage={fieldState.error?.message}
                    onChange={field.onChange}
                />
            )}
        />
    )
}
